import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconLiftAccess: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.7 7.7L12 4.4l3.3 3.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-4-4c-.4-.4-1-.4-1.4 0l-4 4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0zm6.6 8.6L12 19.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4 4c.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zM3 11h18c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
